<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('menu.assignLoanOfficerOldClient') }}
        </h3>
        <div class="box-tools pull-right">
          <template v-if="can([$Permissions.backend.setting.assignLoanOfficerOldClient.store])">
            <button
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#createLoanOfficerAssignment"
            >
              <i class="fa fa-plus-circle" /> {{ $t('button.add') }}
            </button>
          </template>
        </div>
      </div>
      <div class="box-body">
        <table
          id="loan-officer-assign"
          class="table table-hover table-striped table-bordered"
        >
          <tbody />
        </table>
      </div>
    </div>
    <CreateLoanOfficerAssignment
      :products="products"
      @refreshList="oTable.draw()"
    />
    <EditLoanOfficerAssignment
      :products="products"
      @refreshList="oTable.draw()"
    />
  </div>
</template>

<script>
import CreateLoanOfficerAssignment from './modals/CreateLoanOfficerAssignment'
import EditLoanOfficerAssignment from './modals/EditLoanOfficerAssignment'

export default {
  name: 'List',
  components: { EditLoanOfficerAssignment, CreateLoanOfficerAssignment },
  metaInfo () {
    return {
      title: this.pageTitle,
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  computed: {
    pageTitle () {
      return this.$t('menu.assignLoanOfficerList')
    },
    products () {
      return [
        { id: 1, name: this.$t('product.payday'), value: 'payday' },
        { id: 2, name: this.$t('product.personal'), value: 'personal' },
        { id: 3, name: this.$t('product.purchasing'), value: 'purchasing' },
        { id: 4, name: this.$t('product.pawn'), value: 'pawn' }
      ]
    }
  },
  watch: {
    '$i18n.locale' () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
    }
  },
  methods: {
    onDelete (id) {
      this.onConfirm().then((accept) => {
        if (accept) {
          this.$isLoading(true)
          this.$axios.post(this.$base_api + '/api/v4/backend/loan-officer-assignment-old-client/delete', {
            loan_officer_id: id
          }).then(() => {
            this.onDeleted()
            this.oTable.draw()
          }).catch((error) => {
            this.onResponseError(error)
          }).finally(() => {
            this.$isLoading(false)
          })
        }
      })
    },
    refreshTable () {
      return $('#loan-officer-assign').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v4/backend/loan-officer-assignment-old-client/list',
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            width: '2%',
            title: this.$t('table.action'),
            render: (data, type, row) => {
              let action = ''
              if (this.can([this.$Permissions.backend.setting.assignLoanOfficerOldClient.edit])) {
                action += `<button class="btn btn-primary btn-edit btn-xs" title="${this.$t('label.edit')}" data-toggle="modal" data-target="#editLoanOfficerAssignment" data-id="${row.id}"><i class="fa fa-edit"></i> </button> `
              }
              if (this.can([this.$Permissions.backend.setting.assignLoanOfficerOldClient.delete])) {
                action += `<button class="btn btn-danger btn-delete btn-xs" title="${this.$t('label.delete')}" data-id="${row.id}"><i class="fa fa-trash"></i> </button>`
              }

              return action
            }
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            width: '8%',
            title: this.$t('table.createdAt')
          },
          {
            data: 'name',
            name: 'name',
            width: '8%',
            title: this.$t('table.loanOfficerName')
          },
          {
            data: 'id_card',
            name: 'id_card',
            width: '8%',
            title: this.$t('table.id_card'),
            render: (data) => data || this.$t('string.na')
          },
          {
            data: 'product',
            name: 'product',
            width: '8%',
            title: this.$t('table.product')
          }
        ],
        order: [[1, 'desc']],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    enabledAction () {
      this.clearEventHandlers([
        '.btn-delete',
        '.btn-edit'
      ])
      const self = this
      $(document).on('click', '.btn-delete', function () {
        self.onDelete($(this).attr('data-id'))
      })

      $(document).on('click', '.btn-edit', function () {
        const id = $(this).attr('data-id')
        self.$store.commit('loanOfficerAssignment/toggleEditModal')
        self.$store.commit('loanOfficerAssignment/setLoanOfficerAssignment', id)
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.enabledAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
